import React, { useContext, useEffect, useState } from "react";
import { Box, Alert, IconButton, Collapse } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { AlertContext } from "../../components/Dashboard/Dashboard";

export default function AlertNotifier() {

  const { alert, alertText, clear } = useContext(AlertContext);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (alert) { setOpen(true); } else { setOpen(false); }
  }, [alert]);

  return (
    <Box position="relative" sx={{ width: "98%", marginTop: "6px", zIndex: 1210 }}>
      <Collapse in={open}>
        <Alert
          severity={alert || "warning"}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen(false);
                clear();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{
            width: "100%",
            bgcolor: `${alert}.50`,
            color: "black_solid.90",
            "& .MuiAlert-icon": { color: "black_solid.90" },
            "& .MuiAlert-message": { padding: "11px 0" }
          }}
        >
          {alertText}
        </Alert>
      </Collapse>
    </Box>
  );
}